/* eslint-disable no-undef */
// import axios from "axios";
// import { capitalizeFirstLetter } from "components/helper";
import { CLEAR_ADDED, CLEAR_ERRORS, GET_UPDATED_TREND_DATA, SET_TRENDS_LOADING } from "./Types";
// import factory from './actionsFactory';
const factory = require("./actionsFactory");

const URL = process.env.REACT_APP_API;

export const getTrends = (item, isDestination) =>
  factory.get(
    `${URL}/trends?${isDestination ? `destination=${item?.value}` : `location=${item?.value}`}`,
    "GET_TRENDS",
    "TRENDS_FAIL"
  );

export const addTrend = (data) => factory.post(data, `${URL}/trends`, "ADD_TREND", "TRENDS_FAIL");

export const removeTrend = ({ id }) =>
  factory.deleteById(id, `${URL}/trends`, "REMOVE_TREND", "TRENDS_FAIL");

export const saveTrendData = (item, isDestination, isTrip) => ({
  type: GET_UPDATED_TREND_DATA,
  payload: { item, isDestination, isTrip },
});

// Clear Errors
export const clearErrors = () => ({ type: CLEAR_ERRORS });

// Set Loading -- Used for login
export const setLoading = () => ({ type: SET_TRENDS_LOADING });

export const clearAdded = () => ({ type: CLEAR_ADDED });
